module.exports = __webpack_public_path__ + "img/partner-vascomm.5305dcaa.png";